export default `
query getFilterPagesSeoTitleData($filters: ProductAttributeFilterInput!) {
	products (filter: $filters) {
        mw_seo_category_data {
            name
            meta_title
            meta_description
            meta_keywords
            category_seo_name
            description
            canonical_url
            meta_robots
        }
    }
}`;
